import React from 'react'
import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { rules } from "../../../siteData/rules";
import { useContext, useEffect, useRef, useState } from "react";
import { Progress, Upload } from "antd";
import PopComponent from "../../popContent";
import CustomModal from "../../../hoc/CustomModal";
import icon_plus_white from "../../../assets/images/icon_plus_white.svg";
import { ContextState } from "../../../layout";

function ResetPasswordPop({ btnLoader, loading, handleResetPasswordPop, handleChange, categoryData, incomplete_logo, complete_logo, handleModalClose, setFormRef }) {

    const [error, setError] = useState({});
    const [modalName, setModalName] = useState("ResetPasswordPop");
    const [openModal, setModalOpen] = useState(false);
    const [form] = Form.useForm();
    let Modal = PopComponent[modalName];

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const handleFailed = (props) => {
    }

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => handleResetPasswordPop(e, form)}
                onFinishFailed={handleFailed}
                scrollToFirstError
                className="attached_courses-add_skill"
            >
                <h2>Reset Password</h2>
                <Form.Item label="New Password" name="password" rules={rules.password} className="form_group">
                    {/* <h3>New Password</h3> */}
                    <input autoComplete={"off"} name="password" type="text" className="form_control" autoFocus />
                </Form.Item>

                <div className="form_group form_footer">
                    <FilledButton onClick={() => handleModalClose()} type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" loading={btnLoader} className={`btn btn_primary ${btnLoader ? 'disabled' : ''}`} id='btn_loader_primary' value="submit" />
                </div>
            </Form>
            {
                Modal && (
                    <CustomModal className='errorPop modal skill_model' handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={error}
                            handleOpenModal={handleOpenModal}
                        />
                    </CustomModal>
                )
            }
        </div>
    )
}

export default ResetPasswordPop